'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useId, useMemo, useState } from 'react';
import { cn } from '@/utilities/ui';
import mermaid from 'mermaid';
type MermaidRendererProps = {
  source: string;
  className?: string;
};
export default function MermaidRenderer(t0) {
  const $ = _c(12);
  const {
    source,
    className
  } = t0;
  const [svg, setSvg] = useState("");
  const [error, setError] = useState(null);
  const id = useId();
  let t1;
  if ($[0] !== id) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /:/g;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = id.replace(t2, "");
    $[0] = id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const diagramId = `mermaid-${t1}`;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(_temp, t2);
  let t3;
  let t4;
  if ($[4] !== diagramId || $[5] !== source) {
    t3 = () => {
      let cancelled = false;
      const renderDiagram = async () => {
        ;
        try {
          setError(null);
          const rawSource = source.replaceAll("mermaid", "").replaceAll("```", "").replaceAll("\\n", "\n").replaceAll("\\\"", "\\\"").replaceAll("[", "[\"").replaceAll("]", "\"]").replaceAll(">|", ">|\"").replaceAll("-|", "-|\"").replaceAll("| ", "\"|").replaceAll("\\\"", "\"").replaceAll("\"\"", "\"");
          const {
            svg: nextSvg
          } = await mermaid.render(diagramId, rawSource);
          if (!cancelled) {
            setSvg(nextSvg);
          }
        } catch (t5) {
          const renderError = t5;
          if (!cancelled) {
            setSvg("");
            setError(renderError instanceof Error ? renderError.message : "Invalid Mermaid syntax.");
          }
        }
      };
      renderDiagram();
      return () => {
        cancelled = true;
      };
    };
    t4 = [diagramId, source];
    $[4] = diagramId;
    $[5] = source;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== className || $[9] !== error || $[10] !== svg) {
    t5 = <>{error ? <p className="text-destructive text-sm">{error}</p> : <div className={cn("border-border bg-card h-full w-full max-w-none rounded-lg border px-4 py-3 shadow-sm", className)} dangerouslySetInnerHTML={{
        __html: svg
      }} />}</>;
    $[8] = className;
    $[9] = error;
    $[10] = svg;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp() {
  mermaid.initialize({
    startOnLoad: false,
    theme: "default",
    securityLevel: "strict",
    fontSize: 20
  });
}